/* istanbul ignore file */
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faTasks as faTasksLight,
  faUser as faUserLight,
  faHome as faHomeLight,
  faInboxOut as faInboxOutLight,
  faCog as faCogLight,
  faIndustry as faIndustryLight,
  faHandshake as faHandshakeLight,
  faFolder,
  faClipboardCheck,
  faFileCertificate,
  faAddressBook,
  faCommentLines,
  faBriefcase,
  faBook,
  faClipboardList,
  faUsers as faUsersLight,
  faPersonChalkboard as faPersonChalkboardLight,
  faFileImport as faFileImportLight,
  faCalendarCircleUser,
  faFilePen,
  faScreenUsers as faScreenUsersLight,
  faDoorOpen as faDoorOpenLight,
  faTabletScreen as faTabletScreenLight,
  faChartBar,
  faPeopleGroup,
  faBinoculars,
  faStairs,
} from '@fortawesome/pro-light-svg-icons';
import {
  faTasks as faTasksSolid,
  faUser as faUserSolid,
  faHome as faHomeSolid,
  faInboxOut as faInboxOutSolid,
  faCog as faCogSolid,
  faHandshake as faHandshakeSolid,
  faIndustry as faIndustryAlt,
  faCalendarCircleUser as faCalendarCircleUserSolid,
  faFilePen as faFilePenSolid,
  faScreenUsers as faScreenUsersSolid,
  faChartBar as faChartBarSolid,
  faPeopleGroup as faPeopleGroupSolid,
  faBinoculars as faBinocularsSolid,
  faStairs as faStairsSolid,
} from '@fortawesome/pro-solid-svg-icons';
import { homeAreaPathName, homeAreaMenuName } from '../../../areas/area-pathnames';
import { serviceProviderUnitCalendarAreaPathName } from '../../../areas/service-provider-unit-calendar/service-provider-unit-calendar-area-pathnames';
import { serviceProviderUseOfForceAreaPathName } from '../../../areas/service-provider-use-of-force/service-provider-use-of-force-area-pathnames';
import { serviceProviderResourceUtilizationAreaPathName } from '../../../areas/service-provider-resource-utilization/resource-utilization-area-pathnames';
import { serviceProviderUnitOverviewAreaPathName } from '../../../areas/service-provider-unit-overview/service-provider-unit-overview-area-pathnames';
import { managementInformationAreaPathName } from '../../../areas/management-information/management-information-area-pathnames';
import { searchAreaPathName, searchAreaMenuName } from '../../../areas/search/search-area-pathnames';
import {
  citizenAreaMenuName,
  citizenAreaSubMenuName,
  citizensOverviewAreaPathName,
  citizenCreateReportGuide,
} from '../../../areas/citizen/authority/citizen-authority-area-pathnames';
import * as citizensArea from '../../../areas/citizen/authority/overview/citizens-overview-area-pathnames';
import { outboxAreaPathName, outboxAreaMenuName } from '../../../areas/outbox/outbox-area-pathnames';
import { adminAreaPathName, adminAreaMenuName } from '../../../areas/admin/admin-area-pathnames';

import {
  effortsAreaPathName,
  jobAndOffersAreaMenuName,
  jobAndOffersAreaSubMenuName,
  jobAndOffersRecruitmentsRequestsMenuName,
  companyRecruitmentsPathName,
  jobAndOffersCataloguePathName,
  jobAndOffersCatalogueMenuName,
  jobAdsMenuName,
  jobAdsPathName,
} from '../../../areas/efforts/efforts-area-pathnames';
import { companyAreaMenuName, companyAreaSubMenuName, companyAreaPathName } from '../../../areas/company/company-area-pathnames';
import * as companiesArea from '../../../areas/company/overview/company-overview-area-pathnames';
import { ResourceAction } from '../../../authentication/authorization-service';
import { ResourceOperations, ResourceTypes } from '../../../authentication/resources';
import {
  attendanceCourseMenuName,
  attendanceAreaPathName,
  attendanceCoursesAreaPathName,
  attendanceEducatorsPathName,
  attendanceClassroomsPathName,
  attendanceRegistrationCountersPathName,
  attendanceCitizenImport,
} from '../../../areas/attendance/attendance-area-pathnames';
import { citizensAreaCVSearchTabPathName } from '../../../areas/citizen/authority/cv-search/citizens-cv-search-pathnames';
import { forumAreaPathName } from '../../../areas/forum/forum-area-pathnames';

export type NavigationGuid = string;

export interface IMainNavigationItem {
  guid: NavigationGuid;
  name: string;
  subMenuName?: string;
  url: string;
  icon: IconDefinition;
  selectedIcon: IconDefinition;
  exact?: boolean;
  split?: boolean;
  alternative?: boolean;
  children?: IMainNavigationChildItem[];
  featureToggleRequired?: string;
  hideWithFeatureToggle?: string;
  forceRedirect?: boolean;
  resourceActions?: ResourceAction[];
  tenantAddons?: string[];
  requiresServiceProviderRole?: boolean;
  activeOnChildPages?: boolean;
}

export interface IMainNavigationChildItem {
  guid: NavigationGuid;
  name: string;
  url?: string;
  icon?: IconDefinition;
  tenantAddons?: string[];
  openInNewWindow?: boolean;
  useDirectUrl?: boolean;
  openUrlInNewTab?: boolean;
  resourceActions?: ResourceAction[];
  featureToggleRequired?: string;
  hideWithFeatureToggle?: string;
  subMenuName?: string;
  requiresServiceProviderAreaAccess?: boolean;
  requiresServiceProviderRole?: boolean;
}

export const overviewMenuFeatureToggle = 'EnableOverviewMenu';

export const mainNavigationItems: IMainNavigationItem[] = [
  {
    guid: '3ebf66b1-2748-4f05-bad5-ae3fe745e132',
    name: homeAreaMenuName,
    icon: faHomeLight,
    selectedIcon: faHomeSolid,
    url: homeAreaPathName,
    exact: true,
    forceRedirect: true,
  },
  {
    guid: '6e3a1aad-6e9c-480e-bce2-fa8eefe36598',
    name: citizenAreaMenuName,
    subMenuName: citizenAreaSubMenuName,
    icon: faUserLight,
    selectedIcon: faUserSolid,
    url: citizensOverviewAreaPathName,
    children: [
      {
        guid: 'a06dc0c9-48cf-47e7-92c5-64c71a1800d8',
        name: citizensArea.citizensAreaCitizensTabLabel,
        url: citizensArea.citizensAreaCitizensTabPathName,
        icon: faUserLight,
        resourceActions: [{ resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.Citizen }],
        openInNewWindow: false,
      },
      {
        guid: '070c77ca-b739-4a9b-932a-1711685793c0',
        name: citizensArea.citizensAreaCasesTabLabel,
        url: citizensArea.citizensAreaCasesTabPathName,
        icon: faFolder,
        resourceActions: [{ resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.Citizen }],
        openInNewWindow: false,
      },
      {
        guid: '35c02e1e-bf09-4bfd-8606-4c868887fcf6',
        name: citizensArea.citizensAreaTasksTabLabel,
        url: citizensArea.citizensAreaTasksTabPathName,
        icon: faClipboardCheck,
        resourceActions: [{ resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.Citizen }],
        openInNewWindow: false,
      },
      {
        guid: '5e2aaa78-1513-4bfa-988f-3c503469d6c0',
        name: citizensArea.citizensAreaCVSearchTabLabel,
        url: `/${citizensOverviewAreaPathName}/${citizensAreaCVSearchTabPathName}`,
        icon: faFileCertificate,
        resourceActions: [
          { resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.Citizen },
          { resourceOperation: ResourceOperations.Write, resourceType: ResourceTypes.Citizen },
        ],
        tenantAddons: ['virksomhedsservice', 'cV_soegning'],
        openInNewWindow: true,
      },
      {
        guid: 'ea5cc038-ea0c-4d05-a131-20bfd26e155f',
        name: citizensArea.citizensAreaSchultzCaseTabLabel,
        icon: faCommentLines,
        openInNewWindow: true,
        tenantAddons: ['enableSchultzCaseLink'],
        hideWithFeatureToggle: 'EnableSagWebApex',
      },
      {
        guid: '29dcf753-1c84-447c-8f2c-98729ed1e890',
        name: citizensArea.citizensAreaForumTabLabel,
        url: forumAreaPathName,
        icon: faCommentLines,
        openInNewWindow: false,
        featureToggleRequired: 'EnableSagWebApex',
        resourceActions: [{ resourceOperation: ResourceOperations.Write, resourceType: ResourceTypes.CitizenDialog }],
      },
      {
        guid: 'f42d2329-013c-4edc-80c3-435e283112f3',
        name: citizensArea.citizensAreaPrivateContactTabLabel,
        url: citizensArea.citizensAreaPrivateContactTabPathName,
        icon: faAddressBook,
        openInNewWindow: false,
      },
      {
        guid: 'd7f85041-772a-4b16-bb14-4e0a71003f24',
        name: citizensArea.citizensAreaCreateRapportLabel,
        url: `/${citizensOverviewAreaPathName}/${citizenCreateReportGuide}`,
        icon: faClipboardList,
        openInNewWindow: true,
        resourceActions: [{ resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.Report }],
      },
      {
        guid: 'c2582fc4-782b-49ed-8455-1a642e6bc38c',
        name: 'Borgere',
        subMenuName: 'Udfører',
        url: citizensArea.citizensAreaSocialProviderPathName,
        requiresServiceProviderAreaAccess: true,
        icon: faUserLight,
        resourceActions: [
          { resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.SocialProviderSearch },
          { resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.MedicalCollaborationSearch },
        ],
        openInNewWindow: false,
      },
    ],
  },
  {
    guid: '7f2c9d41-6a3e-4b8f-9c5d-1e8a4b7f3c26',
    name: 'Overblik',
    subMenuName: 'Overblik',
    icon: faBinoculars,
    selectedIcon: faBinocularsSolid,
    url: 'overblik',
    featureToggleRequired: overviewMenuFeatureToggle,
    activeOnChildPages: true,
    children: [
      {
        guid: '2b6e8f13-9d4c-4a7e-b1f5-3c9d7e2a6b48',
        name: 'Kalender',
        url: serviceProviderUnitCalendarAreaPathName,
        icon: faCalendarCircleUser,
        useDirectUrl: true,
        tenantAddons: ['JointCalendar'],
        requiresServiceProviderRole: true,
        resourceActions: [{ resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.SocialProviderUnit }],
      },
      {
        guid: 'e4a1c7d9-2f6b-4e3a-8d5c-9b1f6a3e7d52',
        name: 'Ressourceforbrug',
        url: serviceProviderResourceUtilizationAreaPathName,
        icon: faChartBar,
        useDirectUrl: true,
        featureToggleRequired: 'EnableOfferResourceImprovements',
        tenantAddons: ['SocialUdfører'],
        resourceActions: [{ resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.ResourceUtilization }],
      },
      {
        guid: '9d3f5b2e-7c1a-4f8d-a6e4-2b8c5f1d9e37',
        name: 'Magtanvendelser',
        url: serviceProviderUseOfForceAreaPathName,
        icon: faFilePen,
        useDirectUrl: true,
        featureToggleRequired: 'ShowUseOfForce',
        tenantAddons: ['SocialUdfører'],
        resourceActions: [{ resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.UseOfForceIncident }],
      },
      {
        guid: '5c8e2a7f-4b9d-4e1c-b3a6-7f2d9c4e1b85',
        name: 'Enhedsoverblik',
        url: serviceProviderUnitOverviewAreaPathName,
        icon: faPeopleGroup,
        useDirectUrl: true,
        featureToggleRequired: 'ShowAiServiceProviderDemo',
        tenantAddons: ['SocialUdfører'],
        resourceActions: [{ resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.SocialProviderUnit }],
      },
      {
        guid: '6a9e3c1f-8b2d-4f7a-9e5c-3d1b7a8f2e64',
        name: 'Ledelsesinformation',
        url: managementInformationAreaPathName,
        icon: faStairs,
        useDirectUrl: true,
        featureToggleRequired: 'EnableLedelsesinformation',
        tenantAddons: ['Ledelsesinformation'],
      },
    ],
  },
  {
    guid: '9c4a8e7b-5d2f-4b3a-8e1c-7f6d4a2b9e83',
    name: 'Kalender',
    icon: faCalendarCircleUser,
    selectedIcon: faCalendarCircleUserSolid,
    url: serviceProviderUnitCalendarAreaPathName,
    hideWithFeatureToggle: overviewMenuFeatureToggle,
    tenantAddons: ['JointCalendar'],
    requiresServiceProviderRole: true,
    resourceActions: [{ resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.SocialProviderUnit }],
  },
  {
    guid: 'a3d6e2f1-4b7c-4e9a-8d15-6c2b9f0e7a41',
    name: 'Ressourceforbrug',
    icon: faChartBar,
    selectedIcon: faChartBarSolid,
    url: serviceProviderResourceUtilizationAreaPathName,
    featureToggleRequired: 'EnableOfferResourceImprovements',
    hideWithFeatureToggle: overviewMenuFeatureToggle,
    tenantAddons: ['SocialUdfører'],
    resourceActions: [{ resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.ResourceUtilization }],
  },
  {
    guid: '5b1f7c2e-8d4a-4e6b-9a3f-2c7e1d9b4a60',
    name: 'Magtanvendelser',
    icon: faFilePen,
    selectedIcon: faFilePenSolid,
    url: serviceProviderUseOfForceAreaPathName,
    featureToggleRequired: 'ShowUseOfForce',
    hideWithFeatureToggle: overviewMenuFeatureToggle,
    tenantAddons: ['SocialUdfører'],
    resourceActions: [{ resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.UseOfForceIncident }],
  },
  {
    guid: 'd8e4b1a6-3c9f-4f27-a5e0-91b7c6d2f384',
    name: 'Enhedsoverblik',
    icon: faPeopleGroup,
    selectedIcon: faPeopleGroupSolid,
    url: serviceProviderUnitOverviewAreaPathName,
    featureToggleRequired: 'ShowAiServiceProviderDemo',
    hideWithFeatureToggle: overviewMenuFeatureToggle,
    tenantAddons: ['SocialUdfører'],
    resourceActions: [{ resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.SocialProviderUnit }],
  },
  {
    guid: '0b7d3e5a-9c2f-4a61-b8e4-6f1a2d9c7e35',
    name: 'Ledelsesinformation',
    icon: faStairs,
    selectedIcon: faStairsSolid,
    url: managementInformationAreaPathName,
    featureToggleRequired: 'EnableLedelsesinformation',
    hideWithFeatureToggle: overviewMenuFeatureToggle,
    tenantAddons: ['Ledelsesinformation'],
  },
  {
    guid: '3e3a1aad-6e9c-480e-bce2-fa8eefe36558',
    name: companyAreaMenuName,
    subMenuName: companyAreaSubMenuName,
    icon: faIndustryLight,
    selectedIcon: faIndustryAlt,
    url: companyAreaPathName,
    children: [
      {
        guid: 'f06dc0c9-48cf-47e7-92c5-64c71a1801d8',
        name: companiesArea.companiesAreaCompanyTabLabel,
        url: companiesArea.companiesAreaCompanyTabPathName,
        icon: faIndustryLight,
        openInNewWindow: false,
      },
      {
        guid: '75c02e1e-bf09-4bfd-8606-4c863887fcf6',
        name: companiesArea.companiesAreaTasksTabLabel,
        url: companiesArea.companiesAreaTasksTabPathName,
        icon: faClipboardCheck,
        openInNewWindow: false,
      },
      {
        guid: 'f42d2329-013c-4edc-80c3-435e283112f3',
        name: companiesArea.companiesAreaAppointmentsTabLabel,
        url: companiesArea.companiesAreaAppointmentsTabPathName,
        icon: faClipboardCheck,
        openInNewWindow: false,
      },
    ],
  },
  {
    guid: '43fe2e44-f0a3-4462-9940-467c8dfb1f47',
    name: jobAndOffersAreaMenuName,
    subMenuName: jobAndOffersAreaSubMenuName,
    icon: faHandshakeLight,
    selectedIcon: faHandshakeSolid,
    url: effortsAreaPathName,
    children: [
      {
        guid: 'c735c9b4-e6cf-11ea-adc1-0242ac120002',
        name: jobAndOffersRecruitmentsRequestsMenuName,
        icon: faBriefcase,
        url: companyRecruitmentsPathName,
        openInNewWindow: false,
      },
      {
        guid: 'feb88b32-4b58-4834-8c5a-856e3e93594e',
        name: jobAndOffersCatalogueMenuName,
        url: jobAndOffersCataloguePathName,
        icon: faBook,
        resourceActions: [{ resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.Offer }],
        openInNewWindow: false,
      },
      {
        guid: '9fc391d3-f201-454f-ac3d-aa394fb77ea7',
        name: jobAdsMenuName,
        url: jobAdsPathName,
        icon: faBriefcase,
        tenantAddons: ['enableJobAds'],
        resourceActions: [{ resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.JobAd }],
        openInNewWindow: false,
      },
    ],
  },
  {
    guid: '43f675c0-9629-4ee2-be8f-d02012693834',
    name: 'Arbejdsområdet fremmøde',
    subMenuName: 'Fremmøde',
    icon: faScreenUsersLight,
    selectedIcon: faScreenUsersSolid,
    url: 'attendance',
    featureToggleRequired: 'EnableAttendance',
    tenantAddons: ['Attendance'],
    children: [
      {
        guid: 'ed314ab2-fbd3-465b-9224-5a025113360a',
        name: attendanceCourseMenuName,
        url: `${attendanceAreaPathName}/${attendanceCoursesAreaPathName}`,
        icon: faUsersLight,
        resourceActions: [
          { resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.Attendance },
          { resourceOperation: ResourceOperations.Write, resourceType: ResourceTypes.Attendance },
          { resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.AttendanceProtocol },
          { resourceOperation: ResourceOperations.Write, resourceType: ResourceTypes.AttendanceProtocol },
        ],
        openInNewWindow: false,
        useDirectUrl: true,
      },
      {
        guid: '5b4fdcae-0581-4ec3-bbd6-712b11baa968',
        name: 'Underviser',
        url: `${attendanceAreaPathName}/${attendanceEducatorsPathName}`,
        icon: faPersonChalkboardLight,
        resourceActions: [
          { resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.AttendanceFacility },
          { resourceOperation: ResourceOperations.Write, resourceType: ResourceTypes.AttendanceFacility },
        ],
        openInNewWindow: false,
        useDirectUrl: true,
      },
      {
        guid: '8a1d3f6e-2c4b-4e7a-9b5d-0f3e6c8a2d17',
        name: 'Lokaler',
        url: `${attendanceAreaPathName}/${attendanceClassroomsPathName}`,
        icon: faDoorOpenLight,
        resourceActions: [
          { resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.AttendanceFacility },
          { resourceOperation: ResourceOperations.Write, resourceType: ResourceTypes.AttendanceFacility },
        ],
        openInNewWindow: false,
        useDirectUrl: true,
      },
      {
        guid: '3c7e9b2a-5f1d-4a8e-b6c4-9d2f0e7a1b53',
        name: 'Infostandere',
        url: `${attendanceAreaPathName}/${attendanceRegistrationCountersPathName}`,
        icon: faTabletScreenLight,
        resourceActions: [
          { resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.AttendanceFacility },
          { resourceOperation: ResourceOperations.Write, resourceType: ResourceTypes.AttendanceFacility },
        ],
        openInNewWindow: false,
        useDirectUrl: true,
      },
      {
        guid: '2e352c2a-5970-43f8-aee0-865bdf5fffdb',
        name: citizensArea.citizensAreaAttendanceImportLabel,
        useDirectUrl: true,
        url: `/${attendanceAreaPathName}/${attendanceCitizenImport}`,
        icon: faFileImportLight,
        openInNewWindow: true,
        resourceActions: [{ resourceOperation: ResourceOperations.Write, resourceType: ResourceTypes.AttendanceImport }],
      },
    ],
  },
  {
    guid: '68068958-4d33-4119-9bd9-5531e7db05d2',
    name: outboxAreaMenuName,
    icon: faInboxOutLight,
    selectedIcon: faInboxOutSolid,
    url: outboxAreaPathName,
    resourceActions: [{ resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.SystemOutbox }],
  },
  {
    guid: 'ab0ae650-584c-4864-a9f8-0e64831d2d01',
    name: searchAreaMenuName,
    icon: faTasksLight,
    selectedIcon: faTasksSolid,
    url: searchAreaPathName,
    resourceActions: [{ resourceOperation: ResourceOperations.Access, resourceType: ResourceTypes.WorklistQueryBuilder }],
  },
  {
    guid: 'c42680d1-17ba-4419-84ed-452c08303c8f',
    name: adminAreaMenuName,
    icon: faCogLight,
    selectedIcon: faCogSolid,
    url: adminAreaPathName,
    alternative: true,
    split: true,
    resourceActions: [
      { resourceOperation: ResourceOperations.Access, resourceType: ResourceTypes.FasitAdministration },
      { resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.QuestionnaireFeedback },
    ],
  },
];
